import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button,Spinner } from "react-bootstrap";
import { api_url } from "../../constant/constant";
import { useTranslation } from 'react-i18next';
import { showToast } from "../ShowToast/ToastNotification";
import { useLocation } from "react-router-dom";
import { Tab, Tabs } from "react-bootstrap";
import AttachbyuserfilterPhishingcampaign from '../../Components/AttachbyuserfilterPhishingcampaign/AttachbyuserfilterPhishingcampaign'
const AddPhishingCompaignUser = ({ parentfetchLcUserModal }) => {
  // const {question_id} = useParams(); // Get questions_id from the URL
      const [isLoading, setIsLoading] = useState(false); // Loader state
  
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const LcUserModal_id = searchParams.get("LcUserModal_id");
  // console.log("ID is:",LcUserModal_id);
  const { t } = useTranslation();
  const [data, setUsers] = useState([]);
  const [links, setLinks] = useState([]);
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({
    user_ids: "",
  });


  const handleClose = () => {
    setShow(false); // Corrected: Set as boolean `false`
  };
  const handleCheckboxChange = (id) => {
    const alreadySelected = formData.user_ids.includes(id.toString());
    
    const updated = alreadySelected
      ? formData.user_ids.filter(uid => uid !== id.toString())
      : [...formData.user_ids, id.toString()];
  
    setFormData({ ...formData, user_ids: updated });
  };
  const handleSelectAll = (e) => {
    const { checked } = e.target;
    const currentPageIds = data.map(u => u.id.toString());
  
    if (checked) {
      const merged = [...new Set([...(formData.user_ids || []), ...currentPageIds])];
      setFormData({ ...formData, user_ids: merged });
    } else {
      const filtered = formData.user_ids.filter(id => !currentPageIds.includes(id));
      setFormData({ ...formData, user_ids: filtered });
    }
  };
  const handleShow = () => setShow(true);

  const handleChange = (event) => {
    const { options } = event.target;
    const selectedValues = Array.from(options)
      .filter((option) => option.selected)
      .map((option) => option.value);

    setFormData({
      ...formData,
      user_ids: selectedValues, // Update with selected values
    });
  };
  const fetchLcUserModal = async (url) => {
    console.log("Fetching users from:", url);
    
    let finalUrl = `${api_url}/phishing-campaigns/${LcUserModal_id}/non-assigned-users`;
    if (url) {
        finalUrl = url; // use the provided paginated URL
    }

    try {
        const token = localStorage.getItem("userToken");
        const response = await fetch(finalUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();

        if (result?.data?.data?.length > 0) {
            setUsers(result.data.data);
            setLinks(result.data.links); // for pagination UI
        } else {
            setUsers([]);
            showToast(t("noUsersFound"), "warning");
        }
    } catch (error) {
        console.error("Error fetching users:", error);
        showToast(t("failedToFetchUsers"), "error");
    }
};



  useEffect(() => {
    fetchLcUserModal('');
  }, []);

  const handleAddPhishingCompaignUser = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Loader start
  
    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(`${api_url}/phishing-campaigns/${LcUserModal_id}/attach-users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.status=="error"){
          showToast(t(data.message), "success");

        }
        else{
          showToast(t("selectedUsersAdded"), "success");

        }

        setFormData({ user_ids: "" });
        navigate(-1);
        setShow(false);
      } else {
        const data = await response.json();
        showToast(data.message ||t("failedToAddUsers"), "error");
        handleClose();
      }
    } catch (error) {
      showToast(t("somethingWentWrong"), "error");
      handleClose();
    } finally {
      setIsLoading(false); // Loader stop
    }
  };
  

  return (
    <div style={{ border: "1px solid #EAEAEA", borderRadius: "10px", padding: "26px 26px", margin: '20px' }}>
      <div className="d-flex justify-content-end mb-3">
        <Button variant="primary" onClick={() => navigate(-1)} >{t('Back')}</Button>
      </div>

      <Tabs defaultActiveKey="Add Video" className="mb-3">
        <Tab eventKey="Add Video" title={t("AddUserstoPhishingCampaign")}>
          <form onSubmit={handleAddPhishingCompaignUser}>

          <div className="mb-2">
  <input 
    type="checkbox"
    onChange={handleSelectAll}
    checked={
      data.length > 0 &&
      data.every(u => formData.user_ids.includes(u.id.toString()))
    }
  />
  <span style={{ marginLeft: "6px" }}>{t("SelectAllUsers")}</span>
</div>

<table className="table table-bordered">
  <thead>
    <tr>
      <th>{t("Select")}</th>
      <th>{t("Username")}</th>
      <th>{t("Email")}</th>
    </tr>
  </thead>

  <tbody>
    {data.length === 0 ? (
      <tr>
        <td colSpan="3">{t("Nousersavailable")}</td>
      </tr>
    ) : (
      data.map((user) => (
        <tr key={user.id}>
          <td>
            <input
              type="checkbox"
              checked={formData.user_ids.includes(user.id.toString())}
              onChange={() => handleCheckboxChange(user.id)}
            />
          </td>
          <td>{user.username}</td>
          <td>{user.email}</td>
        </tr>
      ))
    )}
  </tbody>
</table>
             <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                                {isLoading ? (
                                                    <>
                                                        <Spinner animation="border" size="sm" role="status" className="me-2" />
                                                        {t('Adding...')}
                                                    </>
                                                ) : (
                                                    t('AddPhishingCampaignUser')
                                                )}
                                            </button>
          </form>
          <div className="navigationWrapper">
            <ul>
                {links.map((link, index) => (

                    <li key={index}
                        className={`${link.active ? " active " : ""} ${link.url === null ? " disabled " : ""}`}
                        onClick={link.url !== null ? () => fetchLcUserModal(link.url) : undefined}
                    >
                        <div dangerouslySetInnerHTML={{ __html: link.label }} />
                    </li>
                ))}
            </ul>
        </div>
        </Tab>
        <Tab eventKey="AttachbyuserfilterPhishingcampaign" title={t("AddUsersUsingQuery")}>
            <AttachbyuserfilterPhishingcampaign />
          </Tab>
      </Tabs>
    </div>
  );
};

export default AddPhishingCompaignUser;
